document.addEventListener("DOMContentLoaded", function () {
    if (document.referrer && document.referrer !== window.location.href) {
        sessionStorage.setItem('backUrl', document.referrer);
    }

    const backButton = document.querySelector('.back-button a');
    if (backButton) {
        backButton.addEventListener('click', function (e) {
            e.preventDefault();
            /*const backUrl = sessionStorage.getItem('backUrl');
            if (backUrl) {
                window.location.href = backUrl;
            } else {
            }*/
            history.back();
        });
    }

    const cancelApply = document.querySelector('.job-application-form .cancel-apply');
    if (cancelApply) { console.log('asdf');
        cancelApply.addEventListener('click', function (e) {
            e.preventDefault();
            const backUrl = sessionStorage.getItem('backUrl');
            if (backUrl) {
                window.location.href = backUrl;
            } else {
                history.back();
            }
        });
    }
});